import React, { useState } from 'react';
import { Button } from 'system/atoms';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { SxProps, Theme } from '@mui/material';

const WIDTH = 230;

const menuContainer: SxProps<Theme> = {
  '& .MuiPaper-root': {
    borderRadius: '8px',
    width: WIDTH,
    border: (theme: Theme) => `1px solid ${theme.palette.divider}`
  },
  '& .MuiList-root': {
    p: 0
  }
};

const itemContainer: SxProps = {
  borderColor: 'primary.main',
  borderWidth: 2,
  borderStyle: 'solid',
  fontWeight: '500',
  color: 'primary.main',
  padding: '12px 18px 12px 18px',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  gap: 1
};

// Define the prop types for the options
export type ActionDropdownOption = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
};

type ActionDropdownProps = {
  options: ActionDropdownOption[];
  disabled?: boolean;
  text?: string;
};

const ActionDropdown: React.FC<ActionDropdownProps> = ({
  options,
  disabled,
  text
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Menu
        id="action-dropdown-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top', // Anchors the menu to the top of the button
          horizontal: 'center' // Centers the menu horizontally in relation to the button
        }}
        transformOrigin={{
          vertical: 'bottom', // Transforms the menu to appear above the button
          horizontal: 'center' // Keeps the menu centered horizontally during the transformation
        }}
        sx={menuContainer}
      >
        {options.map((option) => (
          <MenuItem
            key={option.label.replace(' ', '-').toLowerCase()}
            onClick={() => {
              option.onClick();
              handleClose();
            }}
            sx={itemContainer}
          >
            {option.icon}
            {option.label}
          </MenuItem>
        ))}
      </Menu>
      <Button
        aria-controls="action-dropdown-menu"
        aria-haspopup="true"
        variant="primary"
        onClick={handleClick}
        endIcon={open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        sx={{
          width: WIDTH
        }}
        disabled={disabled}
      >
        {text || 'Action'}
      </Button>
    </div>
  );
};

export { ActionDropdown };
